import React from 'react';

const DistrictRep = props => {
    let phone = <React.Fragment></React.Fragment>,
        email = <React.Fragment></React.Fragment>,
        video = <React.Fragment></React.Fragment>,
        services = <React.Fragment></React.Fragment>;

    if (props.businessPhone) {
        phone =
            <li>
                <svg className="icon icon-phone contact-list-icon"><use xlinkHref="#icon-phone"></use></svg>
                <div className="contact-item-info">
                    <p className="contact-list-label">Phone</p>
                    <a href={`tel:${props.businessPhone}`} className="contact-list-link">{props.businessPhone}</a>
                </div>
            </li>;
    }

    if (props.email) {
        email =
            <li>
                <svg className="icon icon-email-alt contact-list-icon"><use xlinkHref="#icon-email-alt"></use></svg>
                <div className="contact-item-info">
                    <p className="contact-list-label">Email</p>
                    <a href={`mailto:${props.email}`} className="contact-list-link">{props.email}</a>
                </div>
            </li>;
    }

    if (props.videoLink) {
        video =
            <li>
                <svg className="icon icon-play contact-list-icon"><use xlinkHref="#icon-play-blue"></use></svg>
                <div className="contact-item-info">
                    <p className="contact-list-label">Video</p>
                    <a onClick={props.onVideoClick} href={props.videoLink} target="_blank" className="contact-list-link" data-index={props.contactId}>{props.videoTitle}</a>
                </div>
            </li >;
    }

    if (props.services) {
        const serviceList = props.services.split(',').map((s, idx) => s.trim()).filter(Boolean);
        services =
            <li>
                <svg class="icon contact-list-icon"></svg>
                <div className="contact-item-info">
                    <p className="contact-list-label services-label">Services</p>
                    <ul className="contact-list-sublist">
                        {serviceList.map((service, index) => (
                            <li className="service-li" key={index}>{service}</li>
                        ))}
                    </ul>
                </div>
            </li>;
    }

    return (
        <div className="contact blue-border small sales-rep-info">
            <h3 className="contact-title">{props.firstName} {props.lastName} - {props.jobTitle}</h3>
            <ul className="contact-list">
                {phone}
                {email}
                {video}
                {services}
            </ul>
        </div>
    );
};

export default DistrictRep;